import { useRef } from 'react';
import css from "./index.module.scss";
import { useGlobal } from '@/utils/useGlobal';

export default function FontFade({
    children,
    // 默认出现即触发
    offset = 0,
    className = '',
    ...rest
}: any) {
    const { useEffect } = useGlobal();
    const outerBox = useRef<HTMLElement>();

    const list: string[] = [];
    const fonts = children.split('').map((font: string, index: number) => {
        list.push(`
            .fade-font-item_${index} {
                transition: all 0.2s linear 0s;
            }
            .fade-font-item_${index}.enter {
                transition: all 1s cubic-bezier(0.20, 0.00, 0.32, 1.00) ${index * 67}ms;
            }
        `);
        return (
            <span className={`fade-font-item fade-font-item_${index}`} key={index}>{font}</span>
        );
    });

    useEffect(() => {
        let ScrollMagic = (window as any).ScrollMagic;
        const el: HTMLElement = outerBox.current!;

        const styleTag = document.createElement('style');
        styleTag.innerText = list.join('\n');
        document.head.appendChild(styleTag);

        new ScrollMagic.Scene({
            triggerElement: el,
            triggerHook: 1,
            offset: offset,
        })
            .setClassToggle(el?.querySelectorAll('span'), 'enter')
            .addTo(new ScrollMagic.Controller());

    }, []);

    return (
        <div 
            ref={outerBox}
            {...rest} 
            className={`${className} ${css.fontEnterFade} 
            fontFadeEnter`}
        >{fonts}</div>
    );
}